module.exports = __webpack_public_path__ + "assets/img/00037.86aee4f5.png";